var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tbody",
    [
      _c("tr", [
        _c("td", { staticClass: "text-left" }, [
          _vm._v(_vm._s(_vm.line.Quantity)),
        ]),
        _c("td", { staticClass: "text-left" }, [_vm._v(_vm._s(_vm.line.Sku))]),
        _c("td", { staticClass: "text-left" }, [
          _vm._v(_vm._s(_vm.line.Description)),
        ]),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(_vm._s(_vm.formatNumber(_vm.line.UnitPriceExcl))),
        ]),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(_vm._s(_vm.formatDiscount)),
        ]),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(_vm._s(_vm.formatNumber(_vm.line.TotalExcl))),
        ]),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(_vm._s(_vm.line.VATPercentage) + "%"),
        ]),
        _c("td", { staticClass: "text-right" }, [
          _vm._v(_vm._s(_vm.formatNumber(_vm.line.TotalIncl))),
        ]),
      ]),
      _vm._l(_vm.line.Charges, function (charge, i) {
        return _c("tr", { key: i, staticClass: "charge-row" }, [
          _c("td"),
          _c("td"),
          _c("td", { staticClass: "text-left charge-reason" }, [
            _vm._v("↳ " + _vm._s(charge.Reason)),
          ]),
          _c("td"),
          _c("td"),
          _c("td", { staticClass: "text-right" }, [
            _vm._v("+" + _vm._s(_vm.formatNumber(charge.Amount))),
          ]),
          _c("td"),
          _c("td"),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }